import React from "react"
import styles from "./styles.css"
import PropTypes from "prop-types"

const CardFixedVoice = ({ children }) => {
  return <div className={styles.box}>{children}</div>
}

CardFixedVoice.propTypes = {
  children: PropTypes.node
}

export default CardFixedVoice



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/CardFixedVoice/index.js